var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectoricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9.33333V13.7778C10.3333 14.2493 10.5089 14.7015 10.8215 15.0349C11.134 15.3683 11.558 15.5556 12 15.5556C12.442 15.5556 12.866 15.3683 13.1785 15.0349C13.4911 14.7015 13.6667 14.2493 13.6667 13.7778V7.55556C13.6667 6.61256 13.3155 5.70819 12.6904 5.0414C12.0652 4.3746 11.2174 4 10.3333 4C9.44928 4 8.60143 4.3746 7.97631 5.0414C7.35119 5.70819 7 6.61256 7 7.55556V14.6667C7 16.0812 7.52678 17.4377 8.46447 18.4379C9.40215 19.4381 10.6739 20 12 20C13.3261 20 14.5979 19.4381 15.5355 18.4379C16.4732 17.4377 17 16.0812 17 14.6667V5.77778",
    stroke: "#79808A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectoricon);
export default __webpack_public_path__ + "static/media/vectoricon.a52e268158a50c62d73135c609ab8b19.svg";
export { ForwardRef as ReactComponent };